import { Smile, Meh, Frown, type LucideIcon } from 'lucide-react';

// Customer-sentiment display mapping. The AI brain classifies each inbound turn
// as positive | neutral | negative | sarcastic (see ai-brain webhooks). We render
// a coloured face per value on a green → yellow → orange → red scale: green for
// positive, red for negative, and the two ambiguous states in the middle
// (neutral = yellow, sarcastic = orange — a wrapped complaint leaning negative).

export interface SentimentMeta {
  Icon: LucideIcon;
  label: string;
  color: string;
}

export const SENTIMENT_META: Record<string, SentimentMeta> = {
  positive: { Icon: Smile, label: 'Positive', color: '#16a34a' }, // green
  neutral: { Icon: Meh, label: 'Neutral', color: '#eab308' }, // yellow
  sarcastic: { Icon: Meh, label: 'Sarcastic', color: '#ea580c' }, // orange
  negative: { Icon: Frown, label: 'Negative', color: '#dc2626' }, // red
};

export function sentimentMeta(value?: string | null): SentimentMeta | null {
  if (!value) return null;
  return SENTIMENT_META[value.toLowerCase()] ?? null;
}
